import { toast } from "react-toastify";
import FuseUtils from "@fuse/utils/FuseUtils";
import axios from "axios";
/* eslint-disable camelcase */

let baseUrl = process.env.REACT_APP_API_KEY;

class SignupService extends FuseUtils.EventEmitter {
	init() {
		this.setInterceptors();
		this.handleAuthentication();
	}

	setInterceptors = () => {
		axios.interceptors.response.use(
			(response) => {
				return response;
			},
			(err) => {
				return new Promise((resolve, reject) => {
					if (
						err.response.status === 401 &&
						err.config &&
						!err.config.__isRetryRequest
					) {
						// if you ever get an unauthorized response, logout the user
						this.emit("onAutoLogout", "Invalid access_token");
						this.setSession(null);
					}
					throw err;
				});
			}
		);
	};
	setSession = (access_token) => {
		if (access_token) {
			localStorage.setItem("access_token", access_token);
			axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
		} else {
			localStorage.removeItem("access_token");
			localStorage.removeItem("userData");
			delete axios.defaults.headers.common.Authorization;
		}
	};
	handleAuthentication = () => {
		const access_token = this.getAccessToken();

		if (!access_token) {
			this.emit("onNoAccessToken");
			return;
		}

		if (this.isAuthTokenValid(access_token)) {
			this.setSession(access_token);
			this.emit("onAutoLogin", true);
		} else {
			this.setSession(null);
			this.emit("onAutoLogout", "access_token expired");
		}
	};

	createUser = (data) => {
		return new Promise((resolve, reject) => {
			axios.post("/api/auth/register", data).then((response) => {
				if (response.data.user) {
					this.setSession(response.data.access_token);
					resolve(response.data.user);
				} else {
					reject(response.data.error);
				}
			});
		});
	};

	ownerSignup = ({
		firstName,
		lastName,
		email,
		password,
		birthDate,
		phone,
		country,
		state,
		city,
	}) => {
		let data = {
			lat: 37.421875199999995,
			lng: -122.0851173,
			firstName: firstName,
			lastName: lastName,
			email: email,
			password: password,
			birthDate: birthDate,
			phone: phone,
			countryID: country.id,
			stateID: state.id,
			cityID: city.id,
		};

		return new Promise((resolve, reject) => {
			axios
				.post(baseUrl + "owner/signup", data)
				.then((response) => {
					if (response.data.data) {
						this.setSession(response.data.data.authToken);
						resolve(response.data.data);
					} else {
						reject(response.data.error);
					}
					toast.success("Sign up Successfully");
				})
				.catch((error) => {
					toast.error(
						error &&
							error.response &&
							error.response.data &&
							error.response.data.message &&
							error.response.data.message
					);
				});
		});
	};
}

const instance = new SignupService();

export default instance;
